<script setup lang="ts">
const paginationContext = usePaginationContext();

defineProps<{
  ariaLabel?: string;
}>();
</script>

<template>
  <PaginationButton
    :disabled="paginationContext.isNextDisabled.value"
    :aria-label="ariaLabel ?? $t('Pagination.Aria.NextPageButton')"
    :on-click="paginationContext.nextPage"
  >
    <BaseIcon
      name="next"
      prefix="pagination"
    />
  </PaginationButton>
</template>
